import { useEffect, useState } from 'react';

const initialState = {
  students: null,
  parents: null,
  teachers: null,
  assistants: null,
};

const initialStateMinValues = {
  minStudents: null,
  minParents: null,
  minTeachers: null,
  minAssistants: null,
};

export const useFormData = () => {
  const [formValues, setFormValues] = useState(initialState);

  const [minValues, setMinValues] = useState(initialStateMinValues);

  const handleInputChange = (target) => {
    setFormValues({
      ...formValues,
      [target.name]: target.value ? parseInt(target.value, 10) : null,
    });
  };

  const calculateMin = (value) => {
    return value
      ? Math.round(
          value / (1 + (0.05 * 0.05 * (value - 1)) / (1.96 * 1.96 * 0.5 * 0.5))
        )
      : null;
  };

  useEffect(() => {
    setMinValues({
      minStudents: calculateMin(formValues.students),
      minParents: calculateMin(formValues.parents),
      minTeachers: calculateMin(formValues.teachers),
      minAssistants: calculateMin(formValues.assistants),
    });
  }, [formValues]);

  return { formValues, handleInputChange, calculateMin, minValues };
};
